import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { microservices } from '@api/microservices.type';
import { environment } from '@environments/environment';
import { TermsRequestDTO, TermsResponseDTO } from '@shared/models/interfaces/terms-version.interface';
import { User } from '@shared/models/interfaces/user.interface';
import { getStoreUtmsAndGclidValue } from '@shared/utils/get-cookies';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AccountsService {
    readonly http = inject(HttpClient);

    create(): Observable<User> {
        const body = {
            registrationChannel: 'WEB',
        };
        const { gaClid, storeGclid, storeUtms, utmSource } = getStoreUtmsAndGclidValue();
        if (gaClid) {
            Object.assign(body, { gaClid });
        }
        if (storeGclid) {
            Object.assign(body, { storeGclid });
        }
        if (storeUtms) {
            Object.assign(body, { storeUtms });
        }
        if (utmSource) {
            Object.assign(body, { utmSource });
        }
        return this.http.post<User>(`${environment.url}${microservices.accounts}/users`, body);
    }

    getUser(): Observable<User> {
        return this.http.get<User>(`${environment.url}${microservices.accounts}/user`);
    }

    delete(feedback: string) {
        const body = {
            body: {
                feedback: feedback,
            },
        };
        return this.http.delete(`${environment.url}${microservices.accounts}/users`, body);
    }

    updateUser(field: string, value: string): Observable<User> {
        const body = {
            [field]: value,
        };
        return this.http.patch<User>(`${environment.url}${microservices.accounts}/user`, body).pipe(
            catchError((error) => {
                throw error;
            }),
            map((user: User) => {
                return user;
            })
        );
    }

    getPendingTerms(): Observable<TermsResponseDTO> {
        return this.http.get<TermsResponseDTO>(`${environment.url}${microservices.accounts}/user/terms/pending`);
    }

    signTerms(signature: string, signedDocumentIds: string[]): Observable<TermsResponseDTO> {
        const body: TermsRequestDTO = {
            signature,
            signedDocumentIds,
        };
        return this.http.post<TermsResponseDTO>(`${environment.url}${microservices.accounts}/user/terms/signed`, body);
    }
}
